/* eslint-disable */
import React, { useRef } from 'react';
import styles from './LK.module.css';

export default function RateList({ elem, mid }) {
  const scrollRef = useRef(null);
  const selfRowRef = useRef(null);

  const scrollToSelf = () => {
    const container = scrollRef.current;
    const row = selfRowRef.current;
    if (!container || !row) return;
    container.scrollTop = row.offsetTop - container.clientHeight / 2 + row.clientHeight / 2;
  };

  return (
    <div className={styles.card}>
      <div className={`${styles.cardHeader} ${styles.rateHeader}`}>
        <h3 className={styles.cardHeaderTitle}>{elem.name}</h3>
      </div>

      <div className={styles.rateTableWrap} ref={scrollRef}>
        <table className={styles.rateTable}>
          <thead>
            <tr>
              <th className={styles.rateColNum}>#</th>
              <th>Фамилия</th>
              <th className={styles.rateColScore}>Балл</th>
            </tr>
          </thead>
          <tbody>
            {elem.list.map((row) => {
              const isSelf = row.mid === mid;
              return (
                <tr
                  key={row.mid}
                  ref={isSelf ? selfRowRef : null}
                  className={isSelf ? styles.rateRowSelf : styles.rateRow}
                >
                  <td>{row.num}</td>
                  <td>{row.xp_f_get_mid_fio}</td>
                  <td className={styles.rateColScore}>{row.avg}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div className={styles.rateFooter}>
        <button className={styles.findSelfBtn} onClick={scrollToSelf}>
          Найти себя
        </button>
      </div>
    </div>
  );
}
